import { memo } from "react";
import IconMastercard from "app/pages/.shared/static/icons/IconMastercard";
import "./ReassurancePayment.scss";
import PropTypes from "prop-types";
import { CREDIT_CARDS_TYPES, PAYMENT_METHODS } from "app/constants";
import {
	PaiementCbBlackIcon,
	PaiementVisaBlackIcon,
	PaiementAmexBlackIcon,
	PaiementPaypalBlackIcon,
	PaiementGooglepayIcon,
	PaiementApplepayIcon,
	PaiementMastercardBlackIcon,
} from "app/icons/logo";

const iconByPaymentMethod = {
	[CREDIT_CARDS_TYPES.CB]: PaiementCbBlackIcon,
	[CREDIT_CARDS_TYPES.CARTE_BANCAIRE]: PaiementCbBlackIcon,
	[CREDIT_CARDS_TYPES.MASTERCARD]: IconMastercard,
	[CREDIT_CARDS_TYPES.VISA]: PaiementVisaBlackIcon,
	[CREDIT_CARDS_TYPES.AMEX]: PaiementAmexBlackIcon,

	[CREDIT_CARDS_TYPES.CARD]: () => (
		<>
			<PaiementCbBlackIcon width={32} height={32} />
			<PaiementMastercardBlackIcon width={32} height={32} />
			<PaiementVisaBlackIcon width={32} height={32} />
			<PaiementAmexBlackIcon width={32} height={32} />
		</>
	),
	[CREDIT_CARDS_TYPES.GOOGLE_PAY]: PaiementGooglepayIcon,
	[CREDIT_CARDS_TYPES.APPLE_PAY]: PaiementApplepayIcon,
};

// eslint-disable-next-line react/no-multi-comp
const ReassurancePayment = ({ paymentMethods = [] }) => {
	const uniquePaymentMethods = [
		...new Set(
			paymentMethods?.flatMap(
				paymentMethod => paymentMethod.constraints.acceptedCreditCardTypes
			)
		),
	];

	const cardPaymentMethods = uniquePaymentMethods.filter(
		paymentMethod =>
			paymentMethod !== CREDIT_CARDS_TYPES.APPLE_PAY &&
			paymentMethod !== CREDIT_CARDS_TYPES.GOOGLE_PAY
	);

	const mobilePaymentMethods = uniquePaymentMethods.filter(
		paymentMethod =>
			paymentMethod === CREDIT_CARDS_TYPES.APPLE_PAY ||
			paymentMethod === CREDIT_CARDS_TYPES.GOOGLE_PAY
	);

	const hasPaypal = paymentMethods?.some(
		paymentMethod => paymentMethod.code === PAYMENT_METHODS.PAYPAL
	);

	return (
		<div className="reassurance-payment">
			<div className="reassurance-payment__card-payment">
				{cardPaymentMethods.map(card => {
					const CardPaymentIcon = iconByPaymentMethod[card];

					return CardPaymentIcon && <CardPaymentIcon key={card} width={32} height={32} />;
				})}

				{hasPaypal && <PaiementPaypalBlackIcon width={32} height={32} />}
			</div>

			{mobilePaymentMethods.length > 0 && (
				<div className="reassurance-payment__mobile-payment">
					{mobilePaymentMethods.map(mobile => {
						const MobilePaymentIcon = iconByPaymentMethod[mobile];

						return MobilePaymentIcon && <MobilePaymentIcon key={mobile} height={40} />;
					})}
				</div>
			)}
		</div>
	);
};

ReassurancePayment.propTypes = {
	paymentMethods: PropTypes.array,
};

export default memo(ReassurancePayment);
